import { useContext } from 'react';
import { HiveCoreContext } from './HiveCoreProvider';

export function useHiveCoreOptional() {
  try {
    return useContext(HiveCoreContext);
  } catch {
    return null;
  }
}
